export default "__VITE_ASSET__IDZfz$Lo__"